import React from 'react';
interface BetConnectorProps {
  showLine: boolean;
  lineStatusString?: string;
}

const statusClassNames = {
  Unknown: 'bg-transparent border-[var(--muted)]',
  Pending: 'bg-transparent border-[var(--muted)]',
  Won: 'bg-[var(--won)] border-[var(--won)]',
  Lost: 'bg-[var(--lost)] border-[var(--lost)]',
  Refund: 'bg-transparent border-[var(--refund)]',
  HalfWon: 'bg-[var(--won)] border-[var(--won)]',
  HalfLoose: 'bg-[var(--lost)] border-[var(--lost)]',
  Cashout: 'bg-[var(--refund)] border-[var(--refund)]'
}

const BetConnector: React.FC<BetConnectorProps> = ({ showLine, lineStatusString }) => {
  const color = statusClassNames[lineStatusString as keyof typeof statusClassNames]
  
  return (
    <>
      <span className={`decoration-dot absolute left-[8px] top-[22px] w-[12px] h-[12px] rounded-full border-solid border-2 z-10 ${color}`} />
      {showLine && (
        <span
          className="decoraion-line absolute left-[13px] top-[38px] w-[2px] h-[calc(100%-20px)] bg-[color:var(--border)] z-0"
          aria-hidden="true"
        />
      )}
    </>
  );
}

export default BetConnector;
